import {styled} from '@/plugins/emotion'

export const SkeletonWrapper = styled('div')(
  {height: '100%', left: 0, overflow: 'hidden', position: 'absolute', right: 0, width: '100%'},
)
